(function () {
  const getInfoContainer = (root) => {
    if (!root) return null;
    return (
      root.querySelector(`#ProductInfo-${root.dataset.section}`) ||
      root.querySelector('[id^="ProductInfo-"]')
    );
  };

  const moveKitIncludesAboveSizeSelector = (infoContainer) => {
    if (!infoContainer) return;

    const kitBlock = infoContainer.querySelector('[data-pdp-kit-includes]');
    if (!kitBlock) return;

    const sizeLabel = infoContainer.querySelector('.pdp-size-selector-label');
    if (sizeLabel) {
      if (kitBlock.nextElementSibling === sizeLabel) return;
      sizeLabel.insertAdjacentElement('beforebegin', kitBlock);
      return;
    }

    const variantInputs = infoContainer.querySelectorAll(
      '.product-form__input:not(.product-form__quantity)'
    );
    if (variantInputs.length) {
      const firstVariantInput = variantInputs[0];
      if (kitBlock.nextElementSibling === firstVariantInput) return;
      firstVariantInput.insertAdjacentElement('beforebegin', kitBlock);
      return;
    }

    const quantityForm = infoContainer.querySelector(
      `[id="Quantity-Form-${infoContainer.dataset.section || ''}"], [id^="Quantity-Form-"]`
    );
    if (quantityForm) {
      if (kitBlock.nextElementSibling === quantityForm) return;
      quantityForm.insertAdjacentElement('beforebegin', kitBlock);
      return;
    }

    const priceBlock = infoContainer.querySelector(
      `[id="price-${infoContainer.dataset.section || ''}"], [id^="price-"]`
    );
    if (!priceBlock) return;
    if (kitBlock.previousElementSibling === priceBlock) return;
    priceBlock.insertAdjacentElement('afterend', kitBlock);
  };

  const syncKitIncludesTitle = (infoContainer) => {
    if (!infoContainer) return;

    const kitBlock = infoContainer.querySelector('[data-pdp-kit-includes]');
    if (!kitBlock) return;

    const title = kitBlock.querySelector('.pdp-kit-includes__title');
    if (!title) return;

    const rawCount = parseInt(kitBlock.dataset.pdpKitCount || '0', 10) || 0;
    const visualCount = kitBlock.querySelectorAll('.pdp-kit-includes__item').length;
    const itemCount = rawCount > 0 ? rawCount : visualCount;

    if (itemCount > 0) {
      title.textContent =
        itemCount +
        ' Essential PPE Item' +
        (itemCount === 1 ? '' : 's') +
        ' Included';
    }
  };

  const refreshRoot = (root) => {
    const infoContainer = getInfoContainer(root);
    if (!infoContainer) return;

    moveKitIncludesAboveSizeSelector(infoContainer);
    syncKitIncludesTitle(infoContainer);
  };

  const refreshAll = () => {
    document
      .querySelectorAll('product-info[id^="MainProduct-"]')
      .forEach(refreshRoot);
  };

  const queueRefreshAll = () => window.requestAnimationFrame(refreshAll);

  const refreshFromEventTarget = (target) => {
    const root =
      target?.closest?.('product-info[id^="MainProduct-"]') ||
      target?.querySelector?.('product-info[id^="MainProduct-"]') ||
      null;

    if (root) {
      window.requestAnimationFrame(() => refreshRoot(root));
      return;
    }

    queueRefreshAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueRefreshAll, {
      once: true,
    });
  } else {
    queueRefreshAll();
  }

  document.addEventListener('product-info:loaded', (event) => {
    refreshFromEventTarget(event.target);
  });
  document.addEventListener('shopify:section:load', (event) => {
    refreshFromEventTarget(event.target);
  });
  document.addEventListener('shopify:section:reorder', queueRefreshAll);
  document.addEventListener('pdp:kit-count-updated', (event) => {
    refreshFromEventTarget(event.target);
  });
})();
